import { useEffect } from "react";
import { useSelector } from "react-redux";
import { usePushNotifications } from "../hooks/usePushNotifications";
import { RootState } from "../../../redux/store";

const PushNotificationsManager = () => {
  const role = useSelector((state: RootState) => state.auth.role);
  
  const shouldInitializePushNotifications = role === "STORE" || role === "CUSTOMER";

  
  usePushNotifications({ autoInitialize: shouldInitializePushNotifications });

  useEffect(() => {}, []);

  return null;
};

export default PushNotificationsManager;
